import { render, staticRenderFns } from "./SensitiveBehavior.vue?vue&type=template&id=376f9bea&scoped=true&"
import script from "./SensitiveBehavior.vue?vue&type=script&lang=js&"
export * from "./SensitiveBehavior.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveBehavior.vue?vue&type=style&index=0&id=376f9bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f9bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376f9bea')) {
      api.createRecord('376f9bea', component.options)
    } else {
      api.reload('376f9bea', component.options)
    }
    module.hot.accept("./SensitiveBehavior.vue?vue&type=template&id=376f9bea&scoped=true&", function () {
      api.rerender('376f9bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/SensitiveBehavior.vue"
export default component.exports